import { createReducer } from "@reduxjs/toolkit";
import { MapLayersState } from "../actions/MapLayer/types";
import { mapLayersReceived } from "actions";

const initialState: MapLayersState = {
    mapLayers: {
        results: []
    }
};

const mapLayer = createReducer(initialState, (builder) => {
    builder
        .addCase(mapLayersReceived, (state, action) => {
            state.mapLayers = action.payload.data;
        })
        .addDefaultCase((state) => state);
});

export default mapLayer;
